import { TranslateService } from '@ngx-translate/core';

/**
 * CPK-4864: junta os nomes das actions pré-requisito pendentes no formato
 * "'A'", "'A' e 'B'", "'A', 'B' e 'C'" (conjunção vinda do i18n).
 */
export function formatPrereqNames(names: string[], andWord: string): string {
  const quoted = names.map(n => `'${n}'`);
  if (quoted.length <= 1) return quoted.join('');
  return `${quoted.slice(0, -1).join(', ')} ${andWord} ${quoted[quoted.length - 1]}`;
}

/**
 * CPK-4864: tooltip de action bloqueada por pré-requisito. Nunca expõe a
 * description interna da action; sem nomes resolvidos, cai no texto genérico.
 */
export function buildPrereqTooltip(
  names: string[] | undefined,
  translate: TranslateService
): string {
  const valid = (names || []).filter(n => !!n);
  if (valid.length === 0) {
    return translate.instant('CompletePreviousActionsFirst');
  }
  return translate.instant('CompletePrerequisiteActionFirst', {
    names: formatPrereqNames(valid, translate.instant('And')),
  });
}
